import { Tooltip, TooltipProps } from '@material-ui/core';

//component with children
export const CustomTooltip = (props: TooltipProps) => {
  const { children, ...rest } = props;
  return (
    <Tooltip {...rest} PopperProps={{ style: { marginTop: -10 } }} placement="bottom-start">
      <div style={{ overflow: 'hidden', display: 'flex', width: '100%' }}>{children}</div>
    </Tooltip>
  );
};
